import { useEffect, useState } from 'react'

/**
 * The current time, re-read every `ms`. For UI that ages while it sits on
 * screen: a till stays open all day without re-rendering the header, and a
 * shift has to turn stale without anybody pressing reload.
 */
export function useNow(ms = 60_000): Date {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), ms)
    return () => window.clearInterval(id)
  }, [ms])
  return now
}
